import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'LA TUA VERIFICA',
        description: "Qui vedi quanti esercizi hai già scelto per la tua verifica. Entra per vedere l'intera verifica e esportarla.",
        isActive: true,
        name: 'ItemCounterCreaVerifica',
        tutorialName: 'crea-verifica_contatore'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'left',
        xPlacement: 'LEFT',
        yPlacement: 'MIDDLE',
        xOffset: -10,
        yOffset: 3
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'LEFT',
        yPlacement: 'MIDDLE',
        xOffset: -10,
        yOffset: 3
    }
};
